module.exports = __webpack_public_path__ + "img/page5_blackboard_bac.d3e2c4fc.png";